export function bulkTrashConfirmMessage(
  count: number,
  singular: string,
  plural: string,
): string {
  return count === 1
    ? `1 ${singular} vai para a lixeira. Depois você pode restaurar ou excluir em definitivo.`
    : `${count} ${plural} vão para a lixeira. Depois você pode restaurar ou excluir em definitivo.`;
}

export function bulkHardDeleteConfirmMessage(
  count: number,
  singular: string,
  plural: string,
): string {
  return count === 1
    ? `Tem certeza que deseja excluir 1 ${singular}? Esta ação não pode ser desfeita.`
    : `Tem certeza que deseja excluir ${count} ${plural}? Esta ação não pode ser desfeita.`;
}

export function bulkRestoreConfirmMessage(
  count: number,
  singular: string,
  plural: string,
): string {
  return count === 1
    ? `Restaurar 1 ${singular} para a lista?`
    : `Restaurar ${count} ${plural} para a lista?`;
}

export function bulkForceDeleteConfirmMessage(
  count: number,
  singular: string,
  plural: string,
): string {
  return count === 1
    ? `Tem certeza que deseja excluir 1 ${singular} em definitivo? Esta ação não pode ser desfeita.`
    : `Tem certeza que deseja excluir ${count} ${plural} em definitivo? Esta ação não pode ser desfeita.`;
}

export function bulkSimpleConfirmMessage(
  count: number,
  singular: string,
  plural: string,
  action: string,
): string {
  return count === 1
    ? `${action} 1 ${singular}?`
    : `${action} ${count} ${plural}?`;
}
